import { Button, ButtonSize, ButtonVariant, Modal } from "shared/components";
import { InfoCircle } from "untitledui-js-base";
import { QueryKey, useMutation, useQueryClient } from "@tanstack/react-query";
import { instance } from "../../../../../api/apiBase";
import { toast } from "react-toastify";
import { getErrorMessage } from "utils/error";
import { useApplicantIdReportController } from "../../../controller";
import { VerificationNames } from "shared/types";

export const OverrideIdentityModal = ({
  open,
  onClose,
  apiEndpoint,
  invalidateKeys
}: {
  open: boolean;
  onClose: () => void;
  apiEndpoint: string;
  invalidateKeys: QueryKey[];
}) => {
  const { setSearchParams, searchParams } = useApplicantIdReportController();
  const queryClient = useQueryClient();

  const { mutate, isPending } = useMutation({
    mutationFn: () => instance.post(apiEndpoint),
    onSuccess: () => {
      toast.success("Identity successfully overridden");
      invalidateKeys.forEach((key) => {
        queryClient
          .invalidateQueries({
            queryKey: key
          })
          .catch(console.error);
      });
      onClose();
      setSearchParams({
        ...searchParams,
        report: VerificationNames.IdentityVerification
      });
    },
    onError: (error) => {
      toast.error(`Error overriding identity: ${getErrorMessage(error)}`);
    }
  });

  return (
    <Modal
      opened={open}
      onClose={() => onClose()}
      panelClassName="p-6 max-w-[366px] w-full space-y-4"
    >
      <div className="flex items-center justify-center rounded-full bg-danger-50 p-4 mb-6 mx-auto w-16">
        <InfoCircle size="32px" className="stroke-danger-500" />
      </div>

      <h1 className="text-xl font-bold text-content-1000 text-center">
        Manually override a failed identity verification?
      </h1>
      <div className="p-4 bg-danger-50 text-danger-600 rounded-lg">
        <ul className="list-disc pl-5">
          <li className="text-sm font-medium">
            Information provided by the applicant was unable to be fully
            verified by Boom. Overriding identity verification will allow the
            application to continue with running all selected screening
            services.
          </li>
        </ul>
      </div>
      <div className="flex gap-2 w-full">
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.BASE}
          className="w-full"
          onClick={() => onClose()}
        >
          Cancel
        </Button>
        <Button
          size={ButtonSize.BASE}
          variant={ButtonVariant.PRIMARY}
          className="w-full"
          loading={isPending}
          disabled={isPending}
          onClick={() => mutate()}
        >
          Override
        </Button>
      </div>
    </Modal>
  );
};
